import React from "react";
import PropTypes from "prop-types";
import FontAwesome from "react-fontawesome";

import "../schools/Header.css";

class Header extends React.Component {
    static permission = "Admin.Segments";

    render() {
        const { readonly } = this.props;
        return (
            <div className="admin-school-header">
                <button onClick={this.props.onAdd} disabled={readonly}>
                    <FontAwesome name="plus" />
                    <span className="title">ADD SEGMENT</span>
                </button>
            </div>
        );
    }
}

Header.propTypes = {
    onAdd: PropTypes.func.isRequired,
    readonly: PropTypes.bool,
};

export default Header;
